<template>
  <div>
    <search-form
      ref="searchForm"
      :loading="loading"
      :mode="TASK_TYPE_ENUM.SONGLIST"
      :buss-type="mode"
      @search="handleSearch"
    ></search-form>

    <el-card v-loading="loading" class="m-t-md">
      <el-radio-group v-if="mode === LEVEL_ONE_APPEAL.OFFLINE.code" v-model="showExtra">
        <el-radio-button :label="0">简略模式</el-radio-button>
        <el-radio-button :label="1">详细信息</el-radio-button>
      </el-radio-group>
      <span style="float:right">
        <el-button type="primary" :loading="exporting" @click="handleExportAll">全量导出</el-button>
        <el-button type="primary" @click="handleShowBatchUpload">批量上传</el-button>
        <el-button v-if="canCheck" type="primary" @click="handleShowBatchEdit">批量修改</el-button>
        <el-button v-if="canCheck" type="primary" @click="handleShowBatchDelete">批量删除</el-button>
      </span>
      <br>
      <br>

      <el-table :data="tableData" @selection-change="handleSelectChange">
        <el-table-column v-if="canCheck" type="selection"></el-table-column>
        <complaint-info-col v-if="mode === LEVEL_ONE_APPEAL.TORT.code"></complaint-info-col>
        <offline-info-col v-else-if="mode === LEVEL_ONE_APPEAL.OFFLINE.code" :show-extra="!!showExtra"></offline-info-col>
        <white-list-info-col v-else-if="mode === LEVEL_ONE_APPEAL.WHITE_LIST.code"></white-list-info-col>
        <notice-info-col v-else></notice-info-col>
        <complaint-task-info-col></complaint-task-info-col>
        <el-table-column
          align="center"
          fixed="left"
          width="120"
        >
          <template #header>
            <el-button
              v-if="canCheck"
              type="primary"
              :disabled="!tableData.length"
              :loading="saving"
              @click="batchSave()"
            >
              更新状态
            </el-button>
            <span v-else>状态</span>
          </template>
          <template #default="{ row }">
            <el-select v-if="canCheck" v-model="row.tracklistStatus">
              <el-option v-for="(name, id) in appealTrackStatusMap" :key="+id" :label="name" :value="+id"></el-option>
            </el-select>
            <span v-else>{{ appealTrackStatusMap[row.tracklistStatus] }}</span>
          </template>
        </el-table-column>

        <el-table-column
          v-if="canCheck"
          align="center"
          fixed="left"
          width="120"
          label="操作"
          #default="{ row }"
        >
          <el-button
            type="primary"
            class="edit_btn"
            @click="handleShowEdit(row)"
          >
            编辑
          </el-button>

          <el-popconfirm
            confirm-button-text="确认"
            cancel-button-text="取消"
            icon="el-icon-info"
            icon-color="red"
            title="确认删除？"
            @confirm="handleDelete(row.tracklistId)"
          >
            <el-button
              slot="reference"
              type="primary"
              :loading="deletingId === row.tracklistId"
            >
              删除
            </el-button>
          </el-popconfirm>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="pagination.current"
        :page-sizes="[20, 50, 100, 200, 5000]"
        :page-size="pagination.size"
        :total="pagination.total"
        layout="total, sizes, prev, pager, next, jumper"
        class="pagination"
      >
      </el-pagination>
    </el-card>

    <batch-upload-dialog
      :visible.sync="showBatchUpload"
      :mode="TASK_TYPE_ENUM.SONGLIST"
      :buss-type="mode"
      :need-right="isExternalUser"
      @submit="handleUpload"
    ></batch-upload-dialog>

    <batch-edit-dialog
      :visible.sync="showBatchEdit"
      :mode="TASK_TYPE_ENUM.SONGLIST"
      :buss-type="mode"
      :loading="saving"
      @submit="batchSave"
    ></batch-edit-dialog>

    <batch-delete-dialog
      :visible.sync="showBatchDelete"
      :mode="TASK_TYPE_ENUM.SONGLIST"
      :buss-type="mode"
      :loading="batchDeleting"
      @submit="batchDelete"
    >
    </batch-delete-dialog>

    <song-edit-dialog
      :visible.sync="showEdit"
      width="1060px"
      :loading="editing"
      :buss-type="mode"
      :origin-data="editRow"
      @submit="handleSubmitEdit"
    >
    </song-edit-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import complaintService from '@/api/complaint'
import { SongList } from '@/models/Complaint'
import { paginationTableMixin } from '@/utils/mixins'

import SearchForm from '../../SearchForm.vue'
import BatchUploadDialog from '../../BatchUploadDialog.vue'
import BatchEditDialog from '../../BatchEditDialog.vue'
import BatchDeleteDialog from '../../BatchDeleteDialog.vue'
import ComplaintInfoCol from '../../ComplaintInfoCol.vue'
import OfflineInfoCol from '../../OfflineInfoCol.vue'
import WhiteListInfoCol from '../../WhiteListInfoCol.vue'
import ComplaintTaskInfoCol from '../../ComplaintTaskInfoCol.vue'
import NoticeInfoCol from '../../NoticeInfoCol.vue'
import SongEditDialog from './SongEdit'

import {
  TASK_TYPE_ENUM,
  LEVEL_ONE_APPEAL,
  appealTrackStatusMap,
} from '../../../const'

export default {
  name: 'CombineTable',
  components: {
    SearchForm,
    BatchUploadDialog,
    BatchEditDialog,
    BatchDeleteDialog,
    ComplaintInfoCol,
    OfflineInfoCol,
    WhiteListInfoCol,
    ComplaintTaskInfoCol,
    NoticeInfoCol,
    SongEditDialog,
  },
  mixins: [paginationTableMixin],
  props: {
    mode: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      TASK_TYPE_ENUM,
      LEVEL_ONE_APPEAL,
      appealTrackStatusMap,

      showExtra: 0,
      loading: false,
      showBatchUpload: false,
      showBatchEdit: false,
      showBatchDelete: false,
      saving: false,
      batchDeleting: false,
      exporting: false,
      selection: [],

      showEdit: false,
      editing: false,
      editRow: {},
      deletingId: undefined
    }
  },
  computed: {
    ...mapGetters([
      'isExternalUser',
      'isEditor',
      'isAdmin'
    ]),
    /**
     * @returns {Boolean}
     */
    canCheck() {
      return this.isEditor || this.isAdmin
    }
  },
  methods: {
    async fetchData() {
      const params = this.$refs.searchForm.getParams()
      if (!params) return this.$message.warning('请输入任一条件进行查询')

      this.loading = true
      try {
        const resp = await complaintService.findSongList({
          ...(params ?? {}),
          bussType: this.mode,
          page: this.pagination.current - 1,
          num: this.pagination.size
        })
        this.pagination.total = resp.total
        this.tableData = (resp.list || []).map(v => new SongList(v))
      } catch (error) {
        this.$alert(`查询失败.${error.message}`, '错误', {
          type: 'error'
        })
      }
      this.loading = false
    },

    async handleExportAll() {
      const params = this.$refs.searchForm.getParams()
      if (!params) {
        return this.$message.warning('请输入任一条件进行导出')
      }

      this.$notify({
        title: '通知',
        showClose: true,
        message: '正在生成导出任务,请关注邮件或站内通知...',
        position: 'top-right',
        iconClass: 'el-icon-loading',
        duration: 2000
      })

      this.exporting = true
      try {
        await complaintService.exportSongListAll({
          ...(params ?? {}),
          bussType: this.mode,
        })
      } catch (e) {
        this.$alert(`导出失败.${e.message}`, '错误', {
          type: 'error'
        })
      }
      this.exporting = false
    },

    handleShowBatchEdit() {
      this.showBatchEdit = true
    },

    handleShowBatchUpload() {
      this.showBatchUpload = true
    },

    handleShowBatchDelete() {
      this.showBatchDelete = true
    },

    async handleUpload(fileList, rightFileList) {
      try {
        const params = {
          url: fileList[0].url,
          mode: TASK_TYPE_ENUM.SONGLIST,
          complaintType: this.mode,
          rightFileList
        }
        await complaintService.batchUpload(params)
        this.$message.success('上传成功')
      } catch (error) {
        this.$alert(`上传失败.${error.message}`, '错误', {
          type: 'error'
        })
      }
    },

    handleSelectChange(selection) {
      this.selection = selection
    },

    async batchSave(data, fileList, rightFileList) {
      const postData = {
        list: []
      }
      if (!data) {
        if (!this.selection.length) {
          return this.$message.warning('请选中需要修改的记录')
        }

        postData.list = this.selection.map(item => {
          return {
            id: item.tracklistId,
            status: item.tracklistStatus
          }
        })
      } else {
        if (data.ids.length) {
          postData.list = data.ids.map(id => {
            return {
              id,
              status: data.status
            }
          })
        }

        if (fileList.length) {
          postData.url = fileList[0].url
          postData.complaintType = this.mode
        }
      }

      this.saving = true
      try {
        await complaintService.saveSongList(postData)
        this.$message.success('保存成功')

        this.showBatchEdit = false

        if (postData.list?.length) {
          const ids = postData.list.map(v => v.id)
          this.$refs.searchForm.setParam('tracklistIdList', ids)
        }

        // 防止两个 message 重叠
        this.$nextTick(() => {
          this.handleSearch()
        })
      } catch (error) {
        this.$alert(`保存失败.${error.message}`, '错误', {
          type: 'error'
        })
      }
      this.saving = false
    },

    handleShowEdit(row) {
      this.showEdit = true
      this.editRow = row
    },

    async handleSubmitEdit(data) {
      this.editing = true
      try {
        await complaintService.editTrackList(data)
        this.$message.success('编辑成功！')

        this.showEdit = false
        this.editRow = { }
        this.handleSearch()
      } catch (err) {
        this.$message.error('编辑失败：' + err.message)
      }
      this.editing = false
    },

    async handleDelete(id) {
      if (this.deletingId !== undefined) {
        this.$message.warning('其他数据删除中！请稍后尝试！')
        return
      }
      this.deletingId = id
      await this.batchDelete([id])
      this.deletingId = undefined
    },

    async batchDelete(ids) {
      this.batchDeleting = true
      const postData = {
        idList: ids
      }
      try {
        await complaintService.deleteTrackList(postData)
        this.$message.success('删除成功！')
        this.showBatchDelete = false

        this.$nextTick(() => {
          this.handleSearch()
        })
      } catch (err) {
        this.$message.error('删除失败！' + err.message)
      }
      this.batchDeleting = false
    }
  }
}
</script>
<style scope>
.edit_btn{
  margin-right: 6px;
}</style>
